import { FC, Fragment } from "react";
import style from "./ImportantInformation.module.scss";
import classNames from "classnames";

import { DressCodeForLadies } from "./DressCodeForLadies/DressCodeForLadies";
import { DressCodeForGentlemen } from "./DressCodeForGentlemen/DressCodeForGentlemen";
import { FlowersNote } from "./FlowersNote/FlowersNote";
import { GiftsNote } from "./GiftsNote/GiftsNote";
import { Other } from "./Other/Other";

export const ImportantInformation: FC = () => {
  return (
    <Fragment>
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-xl-6">
            <h2 className={classNames(style.title, "section-title light")}>
              <small>Important</small>
              <br />
              <strong>Information</strong>
            </h2>
            <div className={classNames(style.desc, "section-desc")}>
              Dear guests, we eagerly look forward to celebrating with you on
              our special day! To make this occasion even more memorable and
              comfortable for everyone, we’ve prepared a few important details
              to help you get ready. Please take a moment to review the
              information about the dress code, gifts, and other important
              details, so we can all create an unforgettable celebration
              together!
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-8 col-xl-6">
            <ul className="wedding-gifts">
              <DressCodeForLadies />
              <DressCodeForGentlemen />
              <FlowersNote />
              <GiftsNote />
              <Other />
            </ul>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
